import { Typography } from "@mui/material";
import React from "react";
import "../MembershipRegistration/register.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import axios from "axios";
import { styled } from "@mui/material/styles";
import RowRadioButtonsGroup from "../../components/Radio/RowRadioButtonsGroup";
import { notification } from "antd";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const CreateEventCategories = () => {
  const [api, contextHolder] = notification.useNotification();
  const userID = localStorage.getItem("userID");
  // console.log(userID)

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Success",
      description: "Your data has been saved successfully!",
    });
  };

  //parameters declaration
  const key = "12345";
  /* key has no length limit, the longer the length more exhaustive encryption/decryption to process. Key shall not have 0, any 0's will be autoremoved */

  const mode = "YMDHI"; //optional parameter, default will be 'YMDHI'

  //initialize encyptor
  const Encryptor = new InfinityEncryptor(key, mode);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      userID: userID,
      eventCategoryName: "",
      eventCategoryDescription: "",
      eventCategoryType: "",
    },
  });

  async function submitForm(data) {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        "http://localhost/api_server/submit_event_category/",
        data,
        config
      );

      return response.data;
    } catch (error) {
      console.log("API request failed:", error);
    }
  }

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append('userID', data.userID);

    formData.append(
      "eventCategoryName",
      Encryptor.Encrypt(data.eventCategoryName)
    );
    formData.append(
      "eventCategoryDescription",
      Encryptor.Encrypt(data.eventCategoryDescription)
    );
    formData.append(
      "eventCategoryType",
      Encryptor.Encrypt(data.eventCategoryType)
    );

    try {
      const response = await submitForm(formData);
      console.log(response);
      if (response.status === "success") {
        reset();

        openNotificationWithIcon("success");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      console.log("Form submission failed: ", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#e8e8e8",
          height: "auto",
          width: "100vw",
        }}
      >
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />

          <CustomSeparator pageName="event_category" />
          {contextHolder}

          <Typography
            gutterBottom
            variant="h4"
            sx={{ color: "text.secondary" }}
          >
            Create Event Category
          </Typography>
          <form
            onSubmit={handleSubmit(onSubmit, onInvalid, {
              shouldFocusError: true,
            })}
          >
            <Box sx={{ flexGrow: 1, maxWidth: "auto", maxHeight: "auto" }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <label>Event Category Name</label>
                  <TextInput
                    type="text"
                    {...register("eventCategoryName", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.eventCategoryName
                        ? errors.eventCategoryName.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                  <label>Description</label>
                  <TextInput
                    type="text"
                    {...register("eventCategoryDescription", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.eventCategoryDescription
                        ? errors.eventCategoryDescription.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                <label>Category Type </label>
                <RowRadioButtonsGroup
                  {...register("eventCategoryType", {
                    required: "This field is required",
                  })}
                  control={control}
                />
              </Grid>

              <Box textAlign="center">
                <Button
                  sx={{
                    borderRadius: "20px",
                    mt: 4,
                    mb: 4,
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#d33333",
                  }}
                  variant="contained"
                  type="submit"
                >
                  <Typography variant="h6">Save</Typography>
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default CreateEventCategories;
